import { MenuItem } from "@mui/material";
import React from "react";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";

function BoxShadow({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"default"} value={""}>
          default
        </MenuItem>,
        <MenuItem
          key={"Card"}
          value={
            "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px"
          }
        >
          Card (Like in qr)
        </MenuItem>,
        <MenuItem key={"None"} value={"none"}>
          None
        </MenuItem>,
      ]}
      rules={{
        required,
      }}
    />
  );
}

export const JSBoxShadowComponent: JSInputComponent = {
  Component: BoxShadow,
  handlesCssProperties: ["boxShadow"],
};
